// extracted by mini-css-extract-plugin
export default {"main-section__5":"Section5_main-section__5__5To-V","main-section__5__testimonials":"Section5_main-section__5__testimonials__TD0Jr"};